import env from "./env"

const stripeBillingUrl =
  process.env.BLINDINSIGHT_STRIPE_BILLING_URL ||
  env.BLINDINSIGHT_STRIPE_BILLING_URL

export function getStripeBillingPortalUrl(email) {
  const q = new URLSearchParams()
  if (email) q.set("prefilled_email", email)
  const suffix = q.toString()
  return suffix ? `${stripeBillingUrl}?${suffix}` : stripeBillingUrl
}
